import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "right_cont" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { class: "t6_table_b" }
const _hoisted_5 = { class: "td_center" }
const _hoisted_6 = {
  key: 0,
  class: "pagination"
}
const _hoisted_7 = { class: "t6_table_b t6_table_b2" }
const _hoisted_8 = { colspan: "3" }
const _hoisted_9 = { colspan: "3" }
const _hoisted_10 = { colspan: "3" }

import { myPreComplainList } from '@/config/request';
import { reactive } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore()

const data = reactive({
    userInfo: {} as any,
    tabDataList: [] as any,
})
data.userInfo = store.state.userInfomation
if(!data.userInfo.cuserId){
    console.log('登陆过期');
}
const dialog = reactive({
    dialogVisible: false,
    title: '咨询详情',
    detail: {} as any,
})
const showDetail = (item:any) => {
    dialog.detail = item
    dialog.dialogVisible = true
}
const paginate = reactive({
    pageNo: 1,
    pageSize: 10,
    pageSizes: [5,10,20],
    total: 0,
})
const handleCurrentChange = (index:any) => {
    paginate.pageNo = index
    init()
}
const handleSizeChange = (index:any) => {
    paginate.pageSize = index
    init()
}
const init = async() => {
    const type = '1'    //  1表示咨询
    let param = {
        pageNo: paginate.pageNo, 
        pageSize: paginate.pageSize, 
        createUserId: data.userInfo.cuserId, 
        type: type
    }
    const res = await myPreComplainList(param) as any
    let reaultData = res.result.result
    data.tabDataList = reaultData.records || []
    paginate.total = reaultData.total || 0

}
init()


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "t6_title_h1" }, " 我的咨询 ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { width: "150" }, "咨询标题"),
              _createElementVNode("th", { width: "420" }, "咨询内容"),
              _createElementVNode("th", { width: "170" }, "咨询时间"),
              _createElementVNode("th", { class: "td_center" }, "操作")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.tabDataList, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.maintitle), 1),
                _createElementVNode("td", null, _toDisplayString(item.content), 1),
                _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "success",
                    onClick: ($event: any) => (showDetail(item))
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode("详情", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ])
        ]),
        (data.tabDataList.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "暂无数据"
            }))
          : _createCommentVNode("", true)
      ]),
      (paginate.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_pagination, {
              background: "",
              onCurrentChange: handleCurrentChange,
              onSizeChange: handleSizeChange,
              layout: "sizes, prev, pager, next, ->, total",
              "page-size": paginate.pageSize,
              "page-sizes": paginate.pageSizes,
              total: paginate.total
            }, null, 8, ["page-size", "page-sizes", "total"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: dialog.dialogVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog.dialogVisible) = $event)),
        title: dialog.title,
        width: "80%",
        class: "dialog_content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("th", null, "姓名", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.name), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("th", null, "手机号码", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.telephone), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("th", null, "身份证号码", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.idCard), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("th", null, "电子邮件", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.email), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("th", null, "咨询标题", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.maintitle), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("th", null, "咨询部门", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.departmentName), 1)
                ]),
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("th", null, "咨询时间", -1)),
                  _createElementVNode("td", null, _toDisplayString(dialog.detail.createTime), 1),
                  _cache[12] || (_cache[12] = _createElementVNode("th", null, "是否回复", -1)),
                  _createElementVNode("td", null, [
                    (dialog.detail.sfhf == '1')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          class: "ml-2",
                          type: "success"
                        }, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("是", -1)
                          ]))]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_tag, {
                          key: 1,
                          class: "ml-2",
                          type: "warning"
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode("否", -1)
                          ]))]),
                          _: 1
                        }))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("th", null, "咨询内容", -1)),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(dialog.detail.content), 1)
                ]),
                (dialog.detail.sfhf == '1')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("th", null, "回复内容", -1)),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(dialog.detail.hfnr), 1)
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("th", null, "回复时间", -1)),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(dialog.detail.modifytime), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})